import moment from 'moment';

import { ISelectModel } from 'common/models';
import { calculatedAmountForServiceTable } from 'modules/accommodations/features/reservations/helper';
import { TServiceTableData } from 'modules/accommodations/features/reservations/models';

export const transformedServicesForTable = (
  values: any,
  term: ISelectModel<number>[],
  unitOfMeasures: ISelectModel<number>[],
  from: string,
  to: string,
  numberOfGuestsSum: number,
  servicesTableData: TServiceTableData[],
) => {
  const startDate = moment(from);
  const endDate = moment(to);
  const numberOfDays = endDate.diff(startDate, 'days');

  const calculatedAmountPerUnitOfMeasure = calculatedAmountForServiceTable(
    values.unitOfMeasureId,
    numberOfGuestsSum as number,
    numberOfDays,
  );

  let serviceCurrencySymbolValue = '';
  let serviceCurrencyISOValue = '';
  if (servicesTableData[0]) {
    serviceCurrencySymbolValue = servicesTableData[0].serviceCurrencySymbol;
    serviceCurrencyISOValue = servicesTableData[0].serviceCurrencyISO;
  }

  return {
    id: null,
    rootId: values.serviceId,
    serviceName: term.find((item: ISelectModel<number>) => item.value === values.serviceId)
      ?.label as string,
    objectDefined: false,
    // isBasicService: null,
    unitOfMeasureName: unitOfMeasures.find(
      (item: ISelectModel<number>) => item.value === values.unitOfMeasureId,
    )?.label as string,
    unitOfMeasureId: values.unitOfMeasureId,
    dateFrom: from,
    dateTo: to,
    sellingPricePerUnitOfMeasure: values.sellingPricePerUnitOfMeasure,
    purchasePricePerUnitOfMeasure: values.purchasePricePerUnitOfMeasure,
    serviceCurrencySymbol: serviceCurrencySymbolValue,
    serviceCurrencyISO: serviceCurrencyISOValue,
    amount: calculatedAmountPerUnitOfMeasure,
    totalSellingAmountPerUnitOfMeasure:
      calculatedAmountPerUnitOfMeasure * values.sellingPricePerUnitOfMeasure,
    isEditVisible: true,
    isDeleteVisible: true,
  };
};
